import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowNavigationDirection, WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {DartDealService} from "../../deal-list/dart-deals.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DealModel, DealProjectSummaryModel} from "../../deal-list/deal-list.gql-model";
import {FilteredList} from "../../helpers/filtered-list";

@Component({
  templateUrl: "./manage-dart-deals.template.pug",
  providers: [DartDealService],
})
export class ManageDartDealsComponent extends WorkflowStep {
  dartDeals: FilteredList<DealModel> = new FilteredList<DealModel>({
    searchKeys: ["dealKey"],
    exactMatchSearchKeys: ["id"],
  });

  project: DealProjectSummaryModel = new DealProjectSummaryModel({});
  targetSystem: string = "legacy";
  error: Error;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private dartDealService: DartDealService,
  ) {
    super();
  }

  @handleErrors()
  async importDartDealDialogClosed(event: any) {
    const result = event["value"] as boolean;

    if (result) {
      await this.loadData();
    }
  }

  @handleErrors()
  async remove(dealId) {
    await this.dartDealService.remove(dealId);
    await this.loadData();
  }

  @handleErrors()
  async loadData() {
    const {deals, project} = await this.dartDealService.getFullList(this.workflowTargetInfo.projectId);

    this.project = project;
    this.dartDeals.items = deals;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;

    if (deals.length) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    } else {
      await this.workflowService.setStepStatus(WorkflowStepStatus.InProgress);
    }
  }

  @handleErrors()
  async manageDevices(deal: DealModel): Promise<any> {
    this.workflowService.navigate(
      undefined,
      WorkflowNavigationDirection.Next,
      this.workflowService.nextStep,
      {filter: deal.dealKey},
    );
  }

  @handleErrors()
  async ready() {
    this.loading = true;

    await this.loadData();

    this.loading = false;
  }
}
